<template lang="pug">
  div.container-fluid.background-login.vertical-center.px-0
    div.row.d-flex.justify-content-center
      div.col-12.col-sm-12.col-md-6.col-lg-6
        div.card
          div.spinner.spinner-border.spinner-border-lg.text-primary(v-if="resettingPassword")
          div.card-header
            | Kennwort vergessen?
          div.card-body(:class="{ invisible: resettingPassword }")
            form(@submit.prevent)
              div.form-group
                label(for="email")
                  | E-Mail Adresse
                input.form-control(
                  type="email"
                  id="email"
                  placeholder="Geben Sie Ihre E-Mail Adresse ein"
                  v-model="email"
                  )
              div
                button.mx-3.btn.btn-primary.btn-lg(
                  type="button"
                  @click.stop="sendPasswordReset"
                  :disabled="resettingPassword"
                  )
                  | Neues Kennwort senden
                button.mx-3.btn.btn-secondary(
                  type="button"
                  @click.stop="goBack"
                  :disabled="resettingPassword"
                  )
                  | Zurück
              div.mt-4.pa-2.alert.alert-danger(v-if="showError")
                | Es ist ein Fehler aufgetreten.
              div.mt-4.pa-2.alert.alert-success(v-if="showSuccess")
                div
                  | Bitte prüfen Sie Ihr E-Mail-Postfach.
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ResetPassword',
  data: () => ({
    email: '',
    showError: false,
    showSuccess: false
  }),
  computed: {
    ...mapState({
      resettingPassword: state => !!state.orderFormService.loadingIndicators.requestNewPasswordToken
    })
  },
  watch: {
    email () {
      this.clearError()
    },
    password () {
      this.clearError()
    }
  },
  methods: {
    ...mapActions('authentication', [
      'resetPassword'
    ]),
    ...mapActions('ui', [
      'goBack'
    ]),
    clearError () {
      this.showError = false
      this.showSuccess = false
    },
    async sendPasswordReset () {
      this.clearError()
      this.showSuccess = await this.resetPassword({
        email: this.email
      })
      this.showError = !this.showSuccess
    }
  }
}
</script>
